module.exports = __webpack_public_path__ + "static/img-01.f3b9e1cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/beatmap/img-01.png
// module id = 84
// module chunks = 88197199937824 213720915766396 238909619017770